import { Component, Input } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormField, MatLabel, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

import { CommodityFormComponent } from '../commodity-form/commodity-form.component';
import { MatIconButton } from '@angular/material/button';
import { IconComponent } from '../../shared/icon/icon.component';
import { CurrencyEnum } from '../../../enum/currency.enum';
import { WeightUnitEnum } from '../../../enum/weight-unit.enum';
import { Currency } from '../../../utils/currency';
import { Weight } from '../../../utils/weight';
import { Dimensions } from '../../../utils/dimensions';
import { DimensionUnitEnum } from '../../../enum/dimension-unit.enum';
import { createCommodityFormGroup } from '../../../constants/commodity-form-group';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'app-package-form',
    imports: [
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatPrefix,
    MatSuffix,
    MatLabel,
    CommodityFormComponent,
    MatIconButton,
    IconComponent,
    MatDivider
],
    templateUrl: './package-form.component.html',
    styleUrl: './package-form.component.scss'
})
export class PackageFormComponent {

    @Input()
    public formGroup: FormGroup;

    @Input()
    public currency = CurrencyEnum.USD;

    @Input()
    public weightUnit = WeightUnitEnum.KG;

    @Input()
    public dimensionUnit = DimensionUnitEnum.CM;

    public Currency = Currency;
    public Weight = Weight;
    public Dimensions = Dimensions;

    get formCommodities(): FormArray {
        return this.formGroup.get('commodities') as FormArray;
    }

    commodityGroup(index: number): FormGroup {
        return this.formCommodities.at(index) as FormGroup;
    }

    deleteCommodity(index: number): void {
        this.formCommodities.removeAt(index);
    }

    addCommodity(): void {
        this.formCommodities.push(createCommodityFormGroup());
    }
}
